<template>
    <v-app id="login" class="primary">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-card class="elevation-1 pa-3">
                            <v-card-text>
                                <div class="layout column align-center">
                                    <br>
                                    <img
                                        src="/static/logo.png"
                                        alt="Vue Material Admin"
                                        width="240"
                                    >
                                    <h2 class="flex my-4 primary--text">Admin Tool</h2>
                                </div>
                                <v-form>
                                    <v-text-field
                                        append-icon="person"
                                        name="login"
                                        label="Số điện thoại hoặc email"
                                        type="text"
                                        v-model="model.username"
                                    ></v-text-field>
                                    <v-text-field
                                        append-icon="lock"
                                        name="password"
                                        label="Mật khẩu"
                                        id="password"
                                        type="password"
                                        v-model="model.password"
                                        @keypress.enter="login()"
                                    ></v-text-field>
                                    <br>
                                    <v-btn
                                        block
                                        color="primary"
                                        @click="login"
                                        :loading="loading"
                                    >Đăng nhập</v-btn>
                                    <!-- <br/>
                                    <v-btn block color="primary" flat>Quên mật khẩu</v-btn>-->
                                </v-form>
                            </v-card-text>
                            <!-- <v-card-actions>
                <v-btn icon>
                  <v-icon color="blue">fa fa-facebook-square fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="red">fa fa-google fa-lg</v-icon>
                </v-btn>
                <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn>
                            </v-card-actions>-->
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <v-footer height="auto" class="white pa-3 app--footer">
            <v-spacer/>
            <span
                class="caption"
            >Admin Tool v1.0 powered by Vietmap Motrak &copy; {{ new Date().getFullYear() }}</span>
            <v-spacer/>
        </v-footer>
    </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  data: () => ({
    loading: false,
    model: {
      username: '',
      password: ''
    }
  }),
  computed: {
    ...mapGetters(['loggedUser'])
  },
  mounted () {
    // if (this.loggedUser) {
    //   this.$router.push({ path: '/' });
    // }
  },
  methods: {
    ...mapActions(['loginByUsername', 'getUserInfo']),
    login () {
      this.loading = true;
      this.loginByUsername(this.model)
        .then(() => {
          this.loading = false;
          this.$router.push({ path: '/' });
        })
        .catch(_ => {
          this.loading = false;
          window.getApp.showMessage('Sai tên đăng nhập hoặc mật khẩu', 'error');
        });
    }
  }
};
</script>
<style scoped lang="css">
#login {
    height: 50%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    content: "";
    z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue